// extracted by mini-css-extract-plugin
module.exports = {"btn":"button-module--btn--tjO7e","btnLarge":"button-module--btnLarge--2ml4x"};